module.exports = function(done, value){
  return {value: value, done: !!done};
};


//////////////////
// WEBPACK FOOTER
// /home/readymade/apps/facelift_production/shared/~/core-js/library/modules/_iter-step.js
// module id = 629
// module chunks = 0